import axios from "../axiosInstance";
import type {
  CreateMembershipSkuFormData,
  MembershipSku,
} from "@/modules/hub/features/MembershipSkuManagement/schemas/membershipSkuSchema";

/**
 * Create a new membership SKU
 */
export const createMembershipSku = async (
  data: CreateMembershipSkuFormData,
): Promise<MembershipSku> => {
  const response = await axios.post<MembershipSku>(
    "/api/private/membership-skus",
    data,
  );
  return response.data;
};
